/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import { Select, Empty } from 'antd';
import { useQuery } from '@apollo/react-hooks';
import EMPLOYEES_QUERY from 'shared/graphql/query/employees';

const { Option } = Select;
const SelectEmployeeField = (props) => {
  const [fullName, setFullName] = useState('');
  const { loading, error, data } = useQuery(EMPLOYEES_QUERY, {
    variables: {
      full_name: fullName,
      showData: 10,
    },
    fetchPolicy: 'cache-and-network',
  });

  return (
    <Select
      style={{
        width: '100%',
      }}
      allowClear
      notFoundContent={<Empty description="ไม่มีข้อมูล" image={Empty.PRESENTED_IMAGE_SIMPLE} />}
      loading={loading}
      showSearch
      placeholder="ค้นหา"
      onSearch={(value) => setFullName(value)}
      onChange={(value) => props.onChange(value)}
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {loading || error
        ? []
        : data.employees.employees.map((item) => (
            <Option key={item._id} value={item._id}>
              {item.full_name}
            </Option>
          ))}
    </Select>
  );
};

export default SelectEmployeeField;
